import React, { useState } from 'react'
import { supabase } from '../supabaseClient'
import './CadastrarLeads.css'

const ORIGENS = [
  { value: 'formulario', label: 'Formulário Website' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'indicacao', label: 'Indicação' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'google', label: 'Google Ads' },
  { value: 'telefone', label: 'Telefone' },
  { value: 'pap', label: 'PAP (Venda Porta a Porta)' },
  { value: 'lead_proprio', label: 'Lead Próprio' },
  { value: 'painel_dados', label: 'Painel de Dados' }
]

const CadastrarLeads = ({ onBack, userEmpresa, userId, userRole, onLogout }) => {
  const isPAP = userRole === 'pap'
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    origem: 'pap',
    valor_interesse: '',
    observacoes: ''
  })
  const [loading, setLoading] = useState(false)
  const [messageModal, setMessageModal] = useState({
    show: false,
    title: '',
    message: '',
    type: 'success'
  })

  const closeMessageModal = () => {
    setMessageModal({ show: false, title: '', message: '', type: 'success' })
  }

  const formatCurrencyInput = (value) => {
    const numbers = value.replace(/\D/g, '')
    if (!numbers) return ''
    const amount = parseFloat(numbers) / 100
    return amount.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  const parseCurrencyBR = (value) => {
    if (!value) return null
    const cleanValue = String(value).replace(/\./g, '').replace(',', '.')
    const n = parseFloat(cleanValue)
    return isNaN(n) ? null : n
  }

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11)
    if (digits.length <= 2) return digits ? `(${digits}` : ''
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const empresaId = userEmpresa?.id || userEmpresa
      if (!empresaId && !userId) {
        setMessageModal({
          show: true,
          title: 'Erro',
          message: 'Não foi possível identificar empresa ou usuário. Faça login novamente.',
          type: 'error'
        })
        setLoading(false)
        return
      }

      const agora = new Date()
      const leadData = {
        nome: (formData.nome || '').trim(),
        telefone: (formData.telefone || '').replace(/\D/g, '').trim(),
        origem: formData.origem || 'pap',
        observacoes: (formData.observacoes || '').trim() || null,
        valor_interesse: parseCurrencyBR(formData.valor_interesse),
        status: 'novo_lead',
        data_contato: agora.toISOString().split('T')[0],
        data_hora_contato: agora.toISOString(),
        empresa_id: empresaId,
        responsavel: userId || null
      }

      const { error } = await supabase.from('leads').insert([leadData])

      if (error) throw error

      setMessageModal({
        show: true,
        title: 'Sucesso',
        message: 'Lead cadastrado com sucesso!',
        type: 'success'
      })
      setFormData({
        nome: '',
        telefone: '',
        origem: 'pap',
        valor_interesse: '',
        observacoes: ''
      })
    } catch (err) {
      console.error('Erro ao cadastrar lead:', err)
      setMessageModal({
        show: true,
        title: 'Erro',
        message: err?.message || 'Não foi possível cadastrar o lead. Tente novamente.',
        type: 'error'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="cadastrar-leads-container">
      <header className="cadastrar-leads-header">
        {isPAP ? (
          <button type="button" className="cadastrar-leads-btn-back" onClick={onLogout} aria-label="Sair">
            🚪 Sair
          </button>
        ) : (
          <button type="button" className="cadastrar-leads-btn-back" onClick={onBack} aria-label="Voltar">
            ← Voltar
          </button>
        )}
        <div className="cadastrar-leads-title-wrap">
          <span className="cadastrar-leads-header-icon" aria-hidden>📝</span>
          <h1 className="cadastrar-leads-title">Cadastrar Lead</h1>
          <p className="cadastrar-leads-subtitle">Registre um novo lead de forma rápida e organizada</p>
        </div>
      </header>

      <main className="cadastrar-leads-main">
        <form onSubmit={handleSubmit} className="cadastrar-leads-form">
          <section className="cadastrar-leads-form-card">
            <h2 className="cadastrar-leads-section-title">
              <span className="cadastrar-leads-section-icon">👤</span>
              Dados do lead
            </h2>
          <div className="cadastrar-leads-field">
            <label htmlFor="nome">Nome completo *</label>
            <input
              id="nome"
              type="text"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              required
              placeholder="Nome do lead"
              autoComplete="name"
            />
          </div>

          <div className="cadastrar-leads-field">
            <label htmlFor="telefone">Telefone *</label>
            <input
              id="telefone"
              type="tel"
              value={formData.telefone}
              onChange={(e) => setFormData({ ...formData, telefone: formatPhone(e.target.value) })}
              required
              placeholder="(11) 99999-9999"
              autoComplete="tel"
            />
          </div>

          <div className="cadastrar-leads-field">
            <label htmlFor="origem">Origem *</label>
            <select
              id="origem"
              value={formData.origem}
              onChange={(e) => setFormData({ ...formData, origem: e.target.value })}
              required
            >
              {ORIGENS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>

          <div className="cadastrar-leads-field">
            <label htmlFor="valor_interesse">Valor da conta de energia (R$)</label>
            <input
              id="valor_interesse"
              type="text"
              value={formData.valor_interesse}
              onChange={(e) => setFormData({ ...formData, valor_interesse: formatCurrencyInput(e.target.value) })}
              placeholder="0,00"
              inputMode="decimal"
            />
          </div>

          <h2 className="cadastrar-leads-section-title cadastrar-leads-section-title-obs">
            <span className="cadastrar-leads-section-icon">📋</span>
            Observações
          </h2>
          <div className="cadastrar-leads-field">
            <label htmlFor="observacoes" className="sr-only">Observações</label>
            <textarea
              id="observacoes"
              value={formData.observacoes}
              onChange={(e) => setFormData({ ...formData, observacoes: e.target.value })}
              placeholder="Informações adicionais..."
              rows={3}
            />
          </div>
          </section>

          <div className="cadastrar-leads-actions">
            {!isPAP && (
              <button
                type="button"
                className="cadastrar-leads-btn cadastrar-leads-btn-secondary"
                onClick={onBack}
              >
                Cancelar
              </button>
            )}
            <button
              type="submit"
              className="cadastrar-leads-btn cadastrar-leads-btn-primary"
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Cadastrar lead'}
            </button>
          </div>
        </form>
      </main>

      {/* Modal de mensagem (sucesso/erro) */}
      {messageModal.show && (
        <div
          className="cadastrar-leads-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="message-modal-title"
          onClick={closeMessageModal}
        >
          <div
            className={`cadastrar-leads-modal cadastrar-leads-modal-${messageModal.type}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="cadastrar-leads-modal-header">
              <span className="cadastrar-leads-modal-icon" aria-hidden>
                {messageModal.type === 'success' ? '✓' : '!'}
              </span>
              <h2 id="message-modal-title">{messageModal.title}</h2>
            </div>
            <div className="cadastrar-leads-modal-body">
              <p>{messageModal.message}</p>
            </div>
            <div className="cadastrar-leads-modal-footer">
              <button
                type="button"
                className="cadastrar-leads-btn cadastrar-leads-btn-primary"
                onClick={closeMessageModal}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CadastrarLeads
